(function () {
  'use strict';

  var root = document.querySelector('[data-callnow-root]');
  if (!root) return;

  var endpoint = root.getAttribute('data-worker-endpoint').replace(/\/?$/, '');
  var fallbackPhoneNumber = root.getAttribute('data-phone-number') || '';
  var activePhoneNumber = '';

  var businessTimezone = root.getAttribute('data-business-timezone') || '';
  var openHour = parseInt(root.getAttribute('data-open-hour'), 10);
  var closeHour = parseInt(root.getAttribute('data-close-hour'), 10);
  var closedWeekday = root.getAttribute('data-closed-weekday');

  function isWithinBusinessHours() {
    if (!businessTimezone || isNaN(openHour) || isNaN(closeHour)) return true;
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: businessTimezone, hour: 'numeric', hour12: false, weekday: 'short'
      }).formatToParts(new Date());
      var hour = parseInt(parts.find(function (p) { return p.type === 'hour'; }).value, 10);
      var weekdayMap = { Sun: '0', Mon: '1', Tue: '2', Wed: '3', Thu: '4', Fri: '5', Sat: '6' };
      var weekdayShort = parts.find(function (p) { return p.type === 'weekday'; }).value;
      var weekdayNum = weekdayMap[weekdayShort];
      if (closedWeekday && closedWeekday !== '-1' && weekdayNum === closedWeekday) return false;
      return hour >= openHour && hour < closeHour;
    } catch (e) { return true; }
  }
  var accentColor = root.getAttribute('data-accent-color');
  if (accentColor) root.style.setProperty('--hs-teal', accentColor);

  // ---------- Configured countries (admin-set, which STORE number to dial — unchanged) ----------
  var countriesWrap = root.querySelector('[data-callnow-countries]');
  var countries = Array.prototype.slice.call(countriesWrap.querySelectorAll('[data-country-code]')).map(function (el) {
    return { code: el.getAttribute('data-country-code'), phone: el.getAttribute('data-country-phone') };
  }).filter(function (c) { return c.code && c.phone; });

  var overlay = root.querySelector('[data-callnow-overlay]');
  var closeBtn = root.querySelector('[data-callnow-close]');
  var formView = root.querySelector('[data-callnow-form-view]');
  var connectingView = root.querySelector('[data-callnow-connecting]');
  var desktopView = root.querySelector('[data-callnow-desktop]');
  var returningView = root.querySelector('[data-callnow-returning]');
  var unsupportedView = root.querySelector('[data-callnow-unsupported]');
  var numberDisplay = root.querySelector('[data-callnow-number-display]');
  var copyBtn = root.querySelector('[data-callnow-copy]');
  var form = root.querySelector('[data-callnow-form]');
  var errorEl = root.querySelector('[data-callnow-error]');
  var headlineEl = root.querySelector('[data-callnow-headline]');
  var subEl = root.querySelector('[data-callnow-sub]');
  var openHeadlineText = headlineEl.textContent;
  var openSubText = subEl.textContent;
  var closedHeadlineText = root.getAttribute('data-closed-headline') || openHeadlineText;
  var closedSubheadingText = root.getAttribute('data-closed-subheading') || openSubText;
  var closedSubmitLabelText = root.getAttribute('data-closed-submit-label') || 'Request a Callback';
  var callbackConfirmedView = root.querySelector('[data-callnow-callback-confirmed]');
  var callbackDoneBtn = root.querySelector('[data-callnow-callback-done]');
  var currentlyClosed = false;

  var submitBtn = root.querySelector('[data-callnow-submit]');
  var submitDefaultLabel = submitBtn.textContent;
  var callAgainBtn = root.querySelector('[data-callnow-call-again]');
  var callAgainDefaultLabel = callAgainBtn.textContent;
  var useDifferentBtn = root.querySelector('[data-callnow-use-different]');
  var returningCountEl = root.querySelector('[data-callnow-returning-count]');
  var postCallView = root.querySelector('[data-callnow-postcall]');
  var tryAgainBtn = root.querySelector('[data-callnow-try-again]');
  var doneBtn = root.querySelector('[data-callnow-done]');

  var CONTACT_STORAGE_KEY = 'hs_contact_info';
  var HISTORY_STORAGE_KEY = 'hs_callnow_history';

  function getSavedContact() {
    try {
      var raw = localStorage.getItem(CONTACT_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function saveContact(data) {
    try {
      var existing = getSavedContact() || {};
      var merged = Object.assign({}, existing, data);
      localStorage.setItem(CONTACT_STORAGE_KEY, JSON.stringify(merged));
    } catch (e) {}
  }
  function getCallHistory() {
    try {
      var raw = localStorage.getItem(HISTORY_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  var HISTORY_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 90; // 90 days — after this, ask for details again

  function getCallHistoryFresh() {
    var h = getCallHistory();
    if (!h || !h.lastCallAt) return null;
    if (Date.now() - h.lastCallAt > HISTORY_MAX_AGE_MS) return null;
    return h;
  }
  function markCalled() {
    var prev = getCallHistory();
    var count = (prev && prev.count) ? prev.count + 1 : 1;
    try { localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify({ called: true, lastCallAt: Date.now(), count: count })); } catch (e) {}
    return count;
  }

  // ===================== Phone country combo (flag + dial-code, auto-detect) =====================
  var phoneCombo = root.querySelector('[data-callnow-phone-combo]');
  var phoneTrigger = root.querySelector('[data-callnow-phone-trigger]');
  var phoneTriggerFlag = root.querySelector('[data-callnow-phone-flag]');
  var phoneTriggerCode = root.querySelector('[data-callnow-phone-code]');
  var phoneDropdown = root.querySelector('[data-callnow-phone-dropdown]');
  var phoneSearchInput = root.querySelector('[data-callnow-phone-search]');
  var phoneList = root.querySelector('[data-callnow-phone-list]');
  var phoneLocalInput = form.querySelector('input[name="phone_local"]');

  var detectedDialCode = '1';
  var currentCountryCode = 'US';

  var DIAL_CODES = {
    AF:"93",AL:"355",DZ:"213",AD:"376",AO:"244",AG:"1",AR:"54",AM:"374",AU:"61",AT:"43",
    AZ:"994",BS:"1",BH:"973",BD:"880",BB:"1",BY:"375",BE:"32",BZ:"501",BJ:"229",BT:"975",
    BO:"591",BA:"387",BW:"267",BR:"55",BN:"673",BG:"359",BF:"226",BI:"257",CV:"238",KH:"855",
    CM:"237",CA:"1",CF:"236",TD:"235",CL:"56",CN:"86",CO:"57",KM:"269",CG:"242",CR:"506",
    HR:"385",CU:"53",CY:"357",CZ:"420",DK:"45",DJ:"253",DM:"1",DO:"1",EC:"593",EG:"20",
    SV:"503",GQ:"240",ER:"291",EE:"372",SZ:"268",ET:"251",FJ:"679",FI:"358",FR:"33",GA:"241",
    GM:"220",GE:"995",DE:"49",GH:"233",GR:"30",GD:"1",GT:"502",GN:"224",GW:"245",GY:"592",
    HT:"509",HN:"504",HU:"36",IS:"354",IN:"91",ID:"62",IR:"98",IQ:"964",IE:"353",IL:"972",
    IT:"39",CI:"225",JM:"1",JP:"81",JO:"962",KZ:"7",KE:"254",KI:"686",XK:"383",KW:"965",
    KG:"996",LA:"856",LV:"371",LB:"961",LS:"266",LR:"231",LY:"218",LI:"423",LT:"370",LU:"352",
    MG:"261",MW:"265",MY:"60",MV:"960",ML:"223",MT:"356",MH:"692",MR:"222",MU:"230",MX:"52",
    FM:"691",MD:"373",MC:"377",MN:"976",ME:"382",MA:"212",MZ:"258",MM:"95",NA:"264",NR:"674",
    NP:"977",NL:"31",NZ:"64",NI:"505",NE:"227",NG:"234",KP:"850",MK:"389",NO:"47",OM:"968",
    PK:"92",PW:"680",PS:"970",PA:"507",PG:"675",PY:"595",PE:"51",PH:"63",PL:"48",PT:"351",
    QA:"974",RO:"40",RU:"7",RW:"250",KN:"1",LC:"1",VC:"1",WS:"685",SM:"378",ST:"239",
    SA:"966",SN:"221",RS:"381",SC:"248",SL:"232",SG:"65",SK:"421",SI:"386",SB:"677",SO:"252",
    ZA:"27",KR:"82",SS:"211",ES:"34",LK:"94",SD:"249",SR:"597",SE:"46",CH:"41",SY:"963",
    TW:"886",TJ:"992",TZ:"255",TH:"66",TL:"670",TG:"228",TO:"676",TT:"1",TN:"216",TR:"90",
    TM:"993",TV:"688",UG:"256",UA:"380",AE:"971",GB:"44",US:"1",UY:"598",UZ:"998",VU:"678",
    VA:"379",VE:"58",VN:"84",YE:"967",ZM:"260",ZW:"263"
  };

  var COUNTRY_NAMES = {
    AF:"Afghanistan",AL:"Albania",DZ:"Algeria",AD:"Andorra",AO:"Angola",AG:"Antigua and Barbuda",AR:"Argentina",AM:"Armenia",AU:"Australia",AT:"Austria",
    AZ:"Azerbaijan",BS:"Bahamas",BH:"Bahrain",BD:"Bangladesh",BB:"Barbados",BY:"Belarus",BE:"Belgium",BZ:"Belize",BJ:"Benin",BT:"Bhutan",
    BO:"Bolivia",BA:"Bosnia and Herzegovina",BW:"Botswana",BR:"Brazil",BN:"Brunei",BG:"Bulgaria",BF:"Burkina Faso",BI:"Burundi",CV:"Cabo Verde",KH:"Cambodia",
    CM:"Cameroon",CA:"Canada",CF:"Central African Republic",TD:"Chad",CL:"Chile",CN:"China",CO:"Colombia",KM:"Comoros",CG:"Congo (Congo-Brazzaville)",CR:"Costa Rica",
    HR:"Croatia",CU:"Cuba",CY:"Cyprus",CZ:"Czechia",DK:"Denmark",DJ:"Djibouti",DM:"Dominica",DO:"Dominican Republic",EC:"Ecuador",EG:"Egypt",
    SV:"El Salvador",GQ:"Equatorial Guinea",ER:"Eritrea",EE:"Estonia",SZ:"Eswatini",ET:"Ethiopia",FJ:"Fiji",FI:"Finland",FR:"France",GA:"Gabon",
    GM:"Gambia",GE:"Georgia",DE:"Germany",GH:"Ghana",GR:"Greece",GD:"Grenada",GT:"Guatemala",GN:"Guinea",GW:"Guinea-Bissau",GY:"Guyana",
    HT:"Haiti",HN:"Honduras",HU:"Hungary",IS:"Iceland",IN:"India",ID:"Indonesia",IR:"Iran",IQ:"Iraq",IE:"Ireland",IL:"Israel",
    IT:"Italy",CI:"Ivory Coast",JM:"Jamaica",JP:"Japan",JO:"Jordan",KZ:"Kazakhstan",KE:"Kenya",KI:"Kiribati",XK:"Kosovo",KW:"Kuwait",
    KG:"Kyrgyzstan",LA:"Laos",LV:"Latvia",LB:"Lebanon",LS:"Lesotho",LR:"Liberia",LY:"Libya",LI:"Liechtenstein",LT:"Lithuania",LU:"Luxembourg",
    MG:"Madagascar",MW:"Malawi",MY:"Malaysia",MV:"Maldives",ML:"Mali",MT:"Malta",MH:"Marshall Islands",MR:"Mauritania",MU:"Mauritius",MX:"Mexico",
    FM:"Micronesia",MD:"Moldova",MC:"Monaco",MN:"Mongolia",ME:"Montenegro",MA:"Morocco",MZ:"Mozambique",MM:"Myanmar",NA:"Namibia",NR:"Nauru",
    NP:"Nepal",NL:"Netherlands",NZ:"New Zealand",NI:"Nicaragua",NE:"Niger",NG:"Nigeria",KP:"North Korea",MK:"North Macedonia",NO:"Norway",OM:"Oman",
    PK:"Pakistan",PW:"Palau",PS:"Palestine",PA:"Panama",PG:"Papua New Guinea",PY:"Paraguay",PE:"Peru",PH:"Philippines",PL:"Poland",PT:"Portugal",
    QA:"Qatar",RO:"Romania",RU:"Russia",RW:"Rwanda",KN:"Saint Kitts and Nevis",LC:"Saint Lucia",VC:"Saint Vincent and the Grenadines",WS:"Samoa",SM:"San Marino",ST:"Sao Tome and Principe",
    SA:"Saudi Arabia",SN:"Senegal",RS:"Serbia",SC:"Seychelles",SL:"Sierra Leone",SG:"Singapore",SK:"Slovakia",SI:"Slovenia",SB:"Solomon Islands",SO:"Somalia",
    ZA:"South Africa",KR:"South Korea",SS:"South Sudan",ES:"Spain",LK:"Sri Lanka",SD:"Sudan",SR:"Suriname",SE:"Sweden",CH:"Switzerland",SY:"Syria",
    TW:"Taiwan",TJ:"Tajikistan",TZ:"Tanzania",TH:"Thailand",TL:"Timor-Leste",TG:"Togo",TO:"Tonga",TT:"Trinidad and Tobago",TN:"Tunisia",TR:"Turkey",
    TM:"Turkmenistan",TV:"Tuvalu",UG:"Uganda",UA:"Ukraine",AE:"United Arab Emirates",GB:"United Kingdom",US:"United States",UY:"Uruguay",UZ:"Uzbekistan",VU:"Vanuatu",
    VA:"Vatican City",VE:"Venezuela",VN:"Vietnam",YE:"Yemen",ZM:"Zambia",ZW:"Zimbabwe"
  };

  var PRIMARY_FOR_DIAL = { "1": "US", "7": "RU" };

  function findCountryByDial(digitsOnly) {
    var maxLen = Math.min(4, digitsOnly.length);
    for (var len = maxLen; len >= 1; len--) {
      var candidate = digitsOnly.slice(0, len);
      if (PRIMARY_FOR_DIAL[candidate]) return { code: PRIMARY_FOR_DIAL[candidate], dial: candidate };
      for (var code in DIAL_CODES) {
        if (DIAL_CODES[code] === candidate) return { code: code, dial: candidate };
      }
    }
    return null;
  }

  function applyDialCode(countryCode) {
    var cc = (countryCode || 'US').toUpperCase();
    if (!DIAL_CODES[cc]) cc = 'US';
    currentCountryCode = cc;
    detectedDialCode = DIAL_CODES[cc];
    if (phoneTriggerFlag) phoneTriggerFlag.className = 'fi fi-' + cc.toLowerCase() + ' hs-phone-trigger-flag';
    if (phoneTriggerCode) phoneTriggerCode.textContent = '+' + detectedDialCode;
    if (phoneList) {
      phoneList.querySelectorAll('.hs-phone-dropdown-item').forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-code') === cc);
      });
    }
  }

  function buildPhoneList(filterText) {
    if (!phoneList) return;
    var q = (filterText || '').trim().toLowerCase();
    var codes = Object.keys(DIAL_CODES).sort(function (a, b) {
      return (COUNTRY_NAMES[a] || a).localeCompare(COUNTRY_NAMES[b] || b);
    });
    phoneList.innerHTML = '';
    var shown = 0;
    codes.forEach(function (code) {
      var name = COUNTRY_NAMES[code] || code;
      var dial = DIAL_CODES[code];
      if (q && name.toLowerCase().indexOf(q) === -1 && code.toLowerCase().indexOf(q) === -1 && dial.indexOf(q.replace('+', '')) === -1) return;
      shown++;
      var item = document.createElement('div');
      item.className = 'hs-phone-dropdown-item' + (code === currentCountryCode ? ' is-active' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('data-code', code);
      item.innerHTML =
        '<span class="fi fi-' + code.toLowerCase() + '"></span>' +
        '<span class="hs-phone-dropdown-name"></span>' +
        '<span class="hs-phone-dropdown-dial">+' + dial + '</span>';
      item.querySelector('.hs-phone-dropdown-name').textContent = name;
      item.addEventListener('mousedown', function (e) {
        e.preventDefault();
        applyDialCode(code);
        closePhoneDropdown();
        if (phoneLocalInput) phoneLocalInput.focus();
      });
      phoneList.appendChild(item);
    });
    if (!shown) phoneList.innerHTML = '<div class="hs-phone-dropdown-empty">No country found</div>';
  }

  function openPhoneDropdown() {
    if (!phoneDropdown) return;
    buildPhoneList('');
    phoneDropdown.hidden = false;
    phoneTrigger.setAttribute('aria-expanded', 'true');
    if (phoneSearchInput) { phoneSearchInput.value = ''; setTimeout(function () { phoneSearchInput.focus(); }, 30); }
  }
  function closePhoneDropdown() {
    if (!phoneDropdown) return;
    phoneDropdown.hidden = true;
    phoneTrigger.setAttribute('aria-expanded', 'false');
  }
  if (phoneTrigger) {
    phoneTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (phoneDropdown.hidden) openPhoneDropdown(); else closePhoneDropdown();
    });
  }
  if (phoneSearchInput) phoneSearchInput.addEventListener('input', function () { buildPhoneList(phoneSearchInput.value); });
  document.addEventListener('click', function (e) {
    if (phoneCombo && !phoneCombo.contains(e.target)) closePhoneDropdown();
  });

  applyDialCode('US');
  fetch(endpoint + '/geo')
    .then(function (r) { return r.json(); })
    .then(function (d) { applyDialCode(d && d.country); })
    .catch(function () {});

  if (phoneLocalInput) {
    phoneLocalInput.addEventListener('input', function () {
      if (phoneLocalInput._syncing) return;
      var val = phoneLocalInput.value;
      var prefixMatch = val.match(/^\s*(?:\+|00)(\d{1,4})/);
      if (prefixMatch) {
        var match = findCountryByDial(prefixMatch[1]);
        if (match) {
          applyDialCode(match.code);
          var stripRe = new RegExp('^\\s*(?:\\+|00)\\d{' + match.dial.length + '}[\\s-]*');
          val = val.replace(stripRe, '');
        }
      }
      var cleaned = val.replace(/\D/g, '').slice(0, 12);
      phoneLocalInput._syncing = true;
      phoneLocalInput.value = cleaned;
      phoneLocalInput._syncing = false;
    });
  }

  // prefill combo + local number from a previously-saved full phone string like "+91 7309570692"
  function prefillPhone(savedPhone) {
    if (!savedPhone || !phoneLocalInput) return;
    var val = String(savedPhone).trim();
    var prefixMatch = val.match(/^\s*(?:\+|00)(\d{1,4})/);
    if (prefixMatch) {
      var match = findCountryByDial(prefixMatch[1]);
      if (match) {
        applyDialCode(match.code);
        var stripRe = new RegExp('^\\s*(?:\\+|00)\\d{' + match.dial.length + '}[\\s-]*');
        val = val.replace(stripRe, '');
      }
    }
    phoneLocalInput.value = val.replace(/\D/g, '').slice(0, 12);
  }
  // ===================== end phone combo =====================

  // ---------- Reusable trigger — any element anywhere with this class opens the popup ----------
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.hs-callnow-trigger');
    if (!trigger) return;
    e.preventDefault();
    openPopup();
  });

  function resetAllViews() {
    formView.hidden = true;
    connectingView.hidden = true;
    desktopView.hidden = true;
    returningView.hidden = true;
    postCallView.hidden = true;
    callbackConfirmedView.hidden = true;
    unsupportedView.hidden = true;
    clearTimeout(postCallAutoCloseTimer);
    submitBtn.disabled = false;
    submitBtn.textContent = submitDefaultLabel;
    errorEl.hidden = true;
  }

  function openPopup() {
    overlay.hidden = false;
    resetAllViews();

    currentlyClosed = !isWithinBusinessHours();
    if (currentlyClosed) {
      headlineEl.textContent = closedHeadlineText;
      subEl.textContent = closedSubheadingText;
      submitBtn.textContent = closedSubmitLabelText;
      callAgainBtn.textContent = closedSubmitLabelText;
    } else {
      headlineEl.textContent = openHeadlineText;
      subEl.textContent = openSubText;
      submitBtn.textContent = submitDefaultLabel;
      callAgainBtn.textContent = callAgainDefaultLabel;
    }

    var saved = getSavedContact();
    var history = getCallHistoryFresh();

    if (saved && history && history.called && saved.storePhone) {
      returningView.hidden = false;
      activePhoneNumber = saved.storePhone;
      if (returningCountEl) {
        returningCountEl.textContent = history.count > 1 ? "You've called us " + history.count + ' times before.' : '';
      }
    } else {
      formView.hidden = false;
      if (saved) {
        if (saved.name) form.querySelector('input[name="name"]').value = saved.name;
        if (saved.email) form.querySelector('input[name="email"]').value = saved.email;
        if (saved.phone) prefillPhone(saved.phone);
      }
      var focusTarget = (saved && saved.name)
        ? form.querySelector('input[name="reason"]')
        : form.querySelector('input[name="name"]');
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
    }
    document.addEventListener('keydown', onKeydown);
  }
  function closePopup() {
    overlay.hidden = true;
    document.removeEventListener('keydown', onKeydown);
  }
  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    if (phoneDropdown && !phoneDropdown.hidden) { closePhoneDropdown(); return; }
    closePopup();
  }
  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });

  form.querySelectorAll('input[required]').forEach(function (inp) {
    inp.addEventListener('blur', function () { inp.setAttribute('data-touched', 'true'); });
  });

  function isMobileOrTablet() {
    var ua = navigator.userAgent || '';
    return /mobile|android|iphone|ipad|tablet/i.test(ua);
  }

  var postCallAutoCloseTimer = null;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && !connectingView.hidden) {
      connectingView.hidden = true;
      postCallView.hidden = false;
      postCallAutoCloseTimer = setTimeout(closePopup, 8000);
    }
  });

  tryAgainBtn.addEventListener('click', function () {
    clearTimeout(postCallAutoCloseTimer);
    postCallView.hidden = true;
    connectingView.hidden = false;
    setTimeout(function () {
      window.location.href = 'tel:' + activePhoneNumber;
    }, 300);
  });
  doneBtn.addEventListener('click', function () {
    clearTimeout(postCallAutoCloseTimer);
    closePopup();
  });

  // Real source saved earlier by the "hs_touch" snippet in theme.liquid (used only when this visit has no source of its own).
  function readStoredTouch() {
    try {
      var t = JSON.parse(window.localStorage.getItem('hs_touch') || 'null');
      if (!t || !t.ts || (Date.now() - t.ts) > 30 * 86400000) return null;
      var sp = new URLSearchParams();
      ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { if (t[k]) sp.set(k, t[k]); });
      if (t.gclid) sp.set('gclid', '1');
      if (t.fbclid) sp.set('fbclid', '1');
      return { params: sp, referrer: t.referrer || '' };
    } catch (e) { return null; }
  }
  function detectTrafficSource() {
    var params = new URLSearchParams(window.location.search);
    var ref = document.referrer;
    var refIsOwn = false;
    try { refIsOwn = !!ref && new URL(ref).hostname.replace(/^www\./, '') === window.location.hostname.replace(/^www\./, ''); } catch (e) { /* ignore */ }
    if (!params.get('utm_source') && !params.get('gclid') && !params.get('fbclid') && (!ref || refIsOwn)) {
      var stored = readStoredTouch();
      if (stored) { params = stored.params; ref = stored.referrer; }
    }
    var utmSource = params.get('utm_source');
    var utmMedium = params.get('utm_medium');
    var utmCampaign = params.get('utm_campaign');
    if (params.get('gclid')) return { source: 'google_ads', medium: 'paid', campaign: utmCampaign };
    if (params.get('fbclid')) return { source: 'facebook_ads', medium: 'paid', campaign: utmCampaign };
    if (utmSource) return { source: utmSource, medium: utmMedium || 'unknown', campaign: utmCampaign };
    if (!ref) return { source: 'direct', medium: 'none', campaign: null };
    try {
      var refHost = new URL(ref).hostname.replace(/^www\./, '');
      var thisHost = window.location.hostname.replace(/^www\./, '');
      if (refHost === thisHost) return { source: 'internal', medium: 'site', campaign: null };
      if (/google\./.test(refHost)) return { source: 'google', medium: 'organic', campaign: null };
      if (/bing\./.test(refHost)) return { source: 'bing', medium: 'organic', campaign: null };
      if (/facebook\.|instagram\./.test(refHost)) return { source: refHost, medium: 'social', campaign: null };
      return { source: refHost, medium: 'referral', campaign: null };
    } catch (e) { return { source: 'unknown', medium: 'unknown', campaign: null }; }
  }
  function detectDeviceType() {
    var ua = navigator.userAgent || '';
    if (/tablet|ipad/i.test(ua)) return 'tablet';
    if (/mobile|android|iphone/i.test(ua)) return 'mobile';
    return 'desktop';
  }
  var analyticsContext = {
    trafficSource: detectTrafficSource(),
    deviceType: detectDeviceType(),
    landingPage: window.location.href,
    referrer: document.referrer || null,
    language: navigator.language || null,
    browserTimezone: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (e) { return null; } })(),
    visitorId: (function () { try { var m = document.cookie.match(/(?:^|; )hs_vid=([^;]+)/); return m ? decodeURIComponent(m[1]).slice(0, 64) : null; } catch (e) { return null; } })()
  };

  // ---------- Submit (first-time / manual form) ----------
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorEl.hidden = true;

    if (!form.checkValidity()) {
      form.querySelectorAll('input[required]').forEach(function (inp) { inp.setAttribute('data-touched', 'true'); });
      form.reportValidity();
      return;
    }

    var fd = new FormData(form);
    var localPhone = phoneLocalInput ? phoneLocalInput.value.trim() : fd.get('phone_local');
    submitAndCall({
      name: fd.get('name'),
      email: fd.get('email'),
      phone: '+' + detectedDialCode + ' ' + localPhone,
      reason: fd.get('reason') || null
    }, false);
  });

  // ---------- "Call Again" — returning caller, no form, reuse saved details ----------
  callAgainBtn.addEventListener('click', function () {
    var saved = getSavedContact();
    if (!saved) { returningView.hidden = true; formView.hidden = false; return; }
    submitAndCall({
      name: saved.name,
      email: saved.email,
      phone: saved.phone,
      reason: 'Calling again'
    }, true);
  });

  useDifferentBtn.addEventListener('click', function () {
    returningView.hidden = true;
    formView.hidden = false;
    var nameInput = form.querySelector('input[name="name"]');
    if (nameInput) setTimeout(function () { nameInput.focus(); }, 50);
  });

  function submitAndCall(fields, isRepeat) {
    var priorHistory = getCallHistory();
    var upcomingCallCount = (priorHistory && priorHistory.count) ? priorHistory.count + 1 : 1;

    var payload = {
      name: fields.name,
      email: fields.email,
      phone: fields.phone,
      reason: fields.reason,
      repeat_call: !!isRepeat,
      call_count: upcomingCallCount,
      is_callback_request: currentlyClosed,
      countries: countries,
      fallback_phone: fallbackPhoneNumber,
      site_origin: window.location.origin,
      page_url: window.location.href,
      context: analyticsContext
    };

    var activeBtn = isRepeat ? callAgainBtn : submitBtn;
    var activeLabel = activeBtn.textContent;
    activeBtn.disabled = true;
    activeBtn.textContent = 'Connecting...';

    fetch(endpoint + '/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.error || 'Request failed'); });
        return res.json();
      })
      .then(function (data) {
        if (!data.supported) {
          formView.hidden = true;
          returningView.hidden = true;
          unsupportedView.hidden = false;
          return;
        }
        activePhoneNumber = data.phone || fallbackPhoneNumber;
        saveContact({
          name: payload.name,
          email: payload.email,
          phone: payload.phone,
          storePhone: activePhoneNumber
        });
        markCalled();
        proceedAfterSubmit();
      })
      .catch(function (err) {
        errorEl.textContent = 'Something went wrong — please try again.';
        errorEl.hidden = false;
        console.error('HearSilk call-now error:', err);
      })
      .finally(function () {
        activeBtn.disabled = false;
        activeBtn.textContent = activeLabel;
      });
  }

  function proceedAfterSubmit() {
    formView.hidden = true;
    returningView.hidden = true;

    if (currentlyClosed) {
      callbackConfirmedView.hidden = false;
      return;
    }

    if (isMobileOrTablet() && activePhoneNumber) {
      connectingView.hidden = false;
      setTimeout(function () {
        window.location.href = 'tel:' + activePhoneNumber;
      }, 700);
    } else {
      numberDisplay.textContent = activePhoneNumber;
      desktopView.hidden = false;
    }
  }

  callbackDoneBtn.addEventListener('click', closePopup);

  copyBtn.addEventListener('click', function () {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(activePhoneNumber).then(function () {
        copyBtn.textContent = 'Copied!';
        copyBtn.setAttribute('data-copied', 'true');
        setTimeout(function () {
          copyBtn.textContent = 'Copy';
          copyBtn.removeAttribute('data-copied');
        }, 2000);
      });
    }
  });
})();